import Vue from 'vue';
import Vuex from 'vuex';
import cookies from 'js-cookie';
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        language: window.app.defaultLanguage,
        skin: cookies.get(window.app.sPlatformFlg + 'tiandy_jp_skin') || window.mainSkin,
        leftMenuIndex: '',
        topMenuIndex: '',
        topLogoImageClass: 'top_title_center_logo'
    },
    mutations: {
        SET_LANGUAGE: (state, language) => {
            state.language = language;
            copyState.language = language;
            cookies.set('tiandy_jp_language', language, { expires: 365 });
        },
        SET_SKIN: (state, skin) => {
            state.skin = skin;
            copyState.skin = skin;
            cookies.set(window.app.sPlatformFlg + 'tiandy_jp_skin', skin, { expires: 365 });
        },
        SET_LEFTMENUINDEX: (state, leftMenuIndex) => {
            state.leftMenuIndex = leftMenuIndex;
        },
        SET_TOPMENUINDEX: (state, topMenuIndex) => {
            state.topMenuIndex = topMenuIndex;
        },
        SET_TOPLOGOIMAGECLASS: (state, topLogoImageClass) => {
            state.topLogoImageClass = topLogoImageClass;
        },
        RESET_STATE(state) {
            // for (var i in copyState) {
            //     state[i] = copyState[i]; // 递归赋值
            // }
        }
    },
    actions: {
        setLanguage({ commit }, language) {
            commit('SET_LANGUAGE', language);
        },
        setSkin({ commit }, skin) {
            commit('SET_SKIN', skin);
        },
        setLeftMenuIndex({ commit }, leftMenuIndex) {
            commit('SET_LEFTMENUINDEX', leftMenuIndex);
        },
        setTopMenuIndex({ commit }, topMenuIndex) {
            commit('SET_TOPMENUINDEX', topMenuIndex);
        },
        setTopLogoImageClass({ commit }, topLogoImageClass) {U
            commit('SET_TOPLOGOIMAGECLASS', topLogoImageClass);
        }
    }
});
var copyState = deepClone(store.state); // 拷贝state对象
function deepClone(obj) {
    var newObj = obj instanceof Array ? [] : {};
    for (var i in obj) {
        newObj[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i];
    }
    return newObj;
}
export default store;
